module.exports = __webpack_public_path__ + "static/media/img1.044ced67.jpg";